import { render } from "./BoxingResults.vue?vue&type=template&id=51b9f8da&scoped=true"
import script from "./BoxingResults.vue?vue&type=script&lang=js"
export * from "./BoxingResults.vue?vue&type=script&lang=js"

import "./BoxingResults.vue?vue&type=style&index=0&id=51b9f8da&lang=scss&scoped=true"

import exportComponent from "/var/lib/buildkite-agent/builds/BKxAWS-i-01d4bca84f43bee68-1/assemble-sports/aucklandrugbyleague-livescores-production-vertical-traffic-light/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51b9f8da"]])

export default __exports__